// extracted by mini-css-extract-plugin
export default {"results":"ZYcV3IRWjYksMwSbJI_e","fetching":"C3pYPGJm3s0C9bNg3G8K","blinking-background":"EhBpIZDxVWVTeXDFf2Ro"};